




























import Habit from "@/types/Habit";
import CompletedIcon from "@/components/CompletedIcon.vue";
import FailedIcon from "@/components/FailedIcon.vue";
import SkippedIcon from "@/components/SkippedIcon.vue";
import WeekTable from "@/components/WeekTable.vue";
import getHabitAcomplishmentByDate from "@/utils/getHabitAcomplishmentByDate";
import Vue from "vue";
import getDateFormat from "@/utils/getDateFormat";
export default Vue.extend({
  components: {
    CompletedIcon,
    FailedIcon,
    SkippedIcon,
    WeekTable,
  },
  computed: {
    habitStatus() {
      const today = new Date();
      const habitAcomplishment = getHabitAcomplishmentByDate(today, this.habit);
      return habitAcomplishment?.status;
    },
  },
  data() {
    return {
      showDetails: false,
    };
  },
  props: {
    habit: Object as () => Habit,
  },
  methods: {
    toggleStatus() {
      this.$store.commit("toggleHabitStatus", {
        habitId: this.habit.id,
        date: getDateFormat(new Date()),
      });
      this.$forceUpdate();
    },
    openHabitDetails() {
      this.$router.push(`/details/${this.habit.id}`);
    },
  },
});
